export default "__VITE_ASSET__egWQkezd__"